import { jsxs as a, Fragment as N, jsx as e } from "react/jsx-runtime";
import { forwardRef as v, useState as d, useRef as D, useEffect as R } from "react";
import { d as T, e as H, f as j } from "../../index-CExbjDCE.js";
import { Button as h } from "../Button/Button.js";
import "../Button/ButtonBase.js";
import "../Button/theme.js";
import { TextInput as z } from "../TextInput/index.js";
import { cn as x } from "../../utils/cn.js";
const V = v(
  ({
    value: r,
    className: y,
    onAccept: b,
    onDiscard: g,
    disabled: o,
    readOnly: E,
    ...w
  }, i) => {
    const [n, s] = d(!1), [l, c] = d(r), p = D(null);
    R(() => {
      if (n) {
        c(r);
        const t = p.current;
        setTimeout(() => t?.focus(), 0);
      }
    }, [n, r]);
    const k = (t) => {
      if (p.current = t, typeof i == "function") i(t);
      else if (i) {
        const I = i;
        I.current = t;
      }
    }, u = () => {
      o || E || s(!0);
    }, f = () => {
      o || (b(l), s(!1));
    }, m = () => {
      c(r), s(!1), g?.();
    }, C = (t) => {
      t.key === "Enter" ? (t.preventDefault(), f()) : t.key === "Escape" && (t.preventDefault(), m());
    };
    return /* @__PURE__ */ a(
      "div",
      {
        className: x(
          "group flex items-center gap-2 w-full",
          !n && !o ? "rounded-md px-2 py-1 border border-transparent hover:border-white/30 transition-colors" : "",
          y
        ),
        children: [
          !n && /* @__PURE__ */ a(N, { children: [
            /* @__PURE__ */ e(
              "button",
              {
                type: "button",
                className: x(
                  "flex-1 truncate text-left bg-transparent p-0 m-0",
                  o ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
                ),
                onClick: u,
                title: r,
                "aria-label": "Edit text",
                children: r
              }
            ),
            !o && /* @__PURE__ */ e(
              "button",
              {
                type: "button",
                "aria-label": "Edit",
                onClick: u,
                className: "opacity-0 group-hover:opacity-100 transition-opacity text-white/80 hover:text-white",
                children: /* @__PURE__ */ e(T, {})
              }
            )
          ] }),
          n && /* @__PURE__ */ a("div", { className: "flex items-center gap-2 w-full", children: [
            /* @__PURE__ */ e(
              z,
              {
                type: "text",
                ...w,
                value: l,
                onChange: (t) => c(t.target.value),
                className: "w-full",
                ref: k,
                onKeyDown: C
              }
            ),
            /* @__PURE__ */ e(
              h,
              {
                size: "sm",
                color: "success",
                onClick: f,
                "aria-label": "Accept",
                children: /* @__PURE__ */ e(H, {})
              }
            ),
            /* @__PURE__ */ e(
              h,
              {
                size: "sm",
                color: "red",
                onClick: m,
                "aria-label": "Discard",
                children: /* @__PURE__ */ e(j, {})
              }
            )
          ] })
        ]
      }
    );
  }
);
V.displayName = "InlineEditableTextInput";
export {
  V as InlineEditableTextInput
};
